export enum TelemetrySdkEventName {
    ClientInitialized = "client_initialized",
    ClientDestroyed = "client_destroyed"
}
